import { ReducerChain, withScope } from "@gamedev-web/gamedev-sdk-core";

import { PitchListActions, PitchListData } from "../actions/pitchListActions";
import { PitchListScope } from "../scopes";

export type PitchListState = {
  isLoading: boolean;
  data: PitchListData | null;
  error: string | null;
};

export const initialPitchListState: PitchListState = {
  isLoading: false,
  data: null,
  error: null,
};

export const pitchListReducer = withScope(
  [PitchListScope],
  new ReducerChain<PitchListState>(initialPitchListState)
    .on(PitchListActions.FETCH_START, () => ({
      ...initialPitchListState,
      isLoading: true,
    }))
    .on(PitchListActions.FETCH_COMPLETED, (state, action) => ({
      ...state,
      isLoading: false,
      data: (action as unknown as { data: PitchListData }).data,
      error: null,
    }))
    .on(PitchListActions.FETCH_ERROR, (state, action) => ({
      ...state,
      isLoading: false,
      error: (action as unknown as { error: Error }).error.message,
    }))
    .build()
);
